webpackJsonp([53569954864128],{

/***/ 73:
/***/ (function(module, exports) {

	module.exports = {"days":[{"dayId":1,"title":"Day One","date":"May 24th","day":24,"events":[{"id":1,"emoji":"🥐","className":"","time":{"hours":"10","minutes":"00"},"duration":"1 hour 20 minutes","title":"Registration & Breakfast","description":["Pick up your badge. Take some time to enjoy your morning coffee and pastries."],"showReadMore":false},{"id":2,"emoji":"✨","time":{"hours":"11","minutes":"20"},"className":"height90","title":"Opening","description":[],"showReadMore":false},{"id":3,"emoji":"⭐️","className":"","time":{"hours":"11","minutes":"30"},"title":"Keynote. Even More CSS Secrets","speakerId":1,"description":["CSS Secrets was a series of talks that were loved by audiences all around the globe and led to Lea’s bestselling book “<a href='http://www.amazon.com/CSS-Secrets-Lea-Verou/dp/1449372635?tag=leaverou-20' target='_blank'>CSS&nbsp;Secrets</a>”.","The premise is simple: Ten surprising yet practical things you didn’t know you could do in CSS, live-coded in Lea’s trademark interactive presentation style. This third installment of the series will include new juicy secrets related to CSS Variables, grid layout, variable fonts, blending modes, SVG, and many other things.","Prepare to be inspired again as Lea debuts ten all-new feats of advanced CSS wizardry, which will help you understand CSS at a much deeper level."],"showReadMore":true},{"id":4,"emoji":"✔️","className":"","time":{"hours":"12","minutes":"30"},"title":"Journey through VR and AR with React","speakerId":4,"anchor":"Tomasz-Lakomy-24-12-30","description":["It's time to leave the 2D world of a browser window and venture into the world of enhanced reality JavaScript applications. During the talk, we'll see how to make great VR and AR experiences using just your browser and a bit of React, with live demos included, so we'll get to see them in action!"],"showReadMore":true},{"id":5,"emoji":"☕️️","className":"height90","time":{"hours":"13","minutes":"10"},"title":"Coffee Break","duration":"30 mins","description":[],"showReadMore":false},{"id":6,"emoji":"✔️","className":"","time":{"hours":"13","minutes":"40"},"title":"GraphQL Clients","speakerId":8,"anchor":"Mikhail-Novikov-24-13-40","description":["Single-page apps should be fast, and for that they usually need to cache their data on client side. Previously, we had to build those clients manually. With GraphQL, we can build clients that do lots of that manual work automatically and work with any GraphQL API.","This talk will explore why GraphQL makes it easy to build such clients. It'll start from describing how you would usually build a cache on client-side and how it's built in popular GraphQL clients. Talk will explore on what more can be done to build even more powerful tools and what a future GraphQL client would look like."],"showReadMore":true},{"id":7,"emoji":"✔️","className":"height270","time":{"hours":"14","minutes":"20"},"title":"East meets West: web typography and modern layouts","speakerId":3,"anchor":"Chen-Hui-Jing-24-14-20","description":["This talk traces the parallel history of western and eastern typography from handwriting to the internet age, setting the context for how the web is a brand new medium for typesetting. CSS allows us to implement advanced typographic features and multi-directional layouts, that not only benefits internationalization, but opens up a myriad of options for creative and interesting layouts in general as well."],"showReadMore":true},{"id":8,"emoji":"🍽️","className":"height90","time":{"hours":"15","minutes":"00"},"title":"Lunch","duration":"1 hour 30 mins","description":[],"showReadMore":false},{"id":9,"emoji":"⚡","className":"lightning icon opaque-line","time":{"hours":"16","minutes":"30"},"speakerId":2,"anchor":"Benedikt-Meurer-24-16-30","title":"JavaScript: The fairly odd parts","description":["JavaScript is the new language of choice for many applications, and it’s certainly a great language for many tasks. But it also has some strange quirks. This lightning talk focuses on some of JavaScript’s weird parts, that you usually don’t run into… unless you try to implement a JavaScript VM that correctly follows the language specification."],"showReadMore":true},{"id":10,"emoji":"⚡","className":"lightning icon opaque-line","time":{"hours":"16","minutes":"40"},"speakerId":22,"title":"CSS Tricks You Gotta Love","description":["When you need to make a complex and beautiful UI, then you have to find new approaches. In practice, it turns out that complex things are very simple but sometimes not immediately obvious.","I would like to share working methods from my practice. And you will understand how everything can be simple!"],"showReadMore":true},{"id":11,"emoji":"⚡","className":"lightning icon opaque-line","time":{"hours":"16","minutes":"50"},"speakerId":15,"anchor":"Leonid-Khachaturov-24-16-40","title":"100% Kotlin frontend","description":["Kotlin is much more than a hot new language for Android apps or your server's backend, it is also a fun and efficient way to develop the frontend part of your web-based app. I will demonstrate how to develop a React app (with styled-components, of course!) without ever leaving Kotlin."],"showReadMore":true},{"id":12,"emoji":"⚡","className":"lightning icon opaque-line","time":{"hours":"17","minutes":"00"},"speakerId":16,"anchor":"Gregory-Shehet-25-16-10","title":"React Native: New Age Hack or Stone Age Tool?","description":["React Native is currently a very popular library for writing native applications. It’s super easy to get started with it if you already know React — you can think that you’ve become a mobile developer in less than 15 minutes!","However, while React Native may make it easy for front-end developers to get started with mobile development, it’s severely lacking in comparison to more established and comprehensive languages like Swift or Kotlin. Compared to Swift or Kotlin, React Native seems like it’s from the Stone Ages!","So the question is, should you use React Native in production ? In my talk, I will tell you about the pros and cons of React Native."],"showReadMore":true},{"id":13,"emoji":"⚡","className":"lightning icon opaque-line","time":{"hours":"17","minutes":"10"},"speakerId":12,"anchor":"Michaela-Lehr-24-16-50","title":"Using New Web APIs For Your Own Pleasure","description":["When I first heard about the Web Bluetooth API I was so curious, that I could not wait to try it out. So I asked myself: Which Bluetooth device should I buy? Especially if I do not want to through it away after I was finished experimenting with the API.","So obviously a Bluetooth enabled vibrator was a perfect fit. And it came with a serious use case, too: The slogan of the vibrator was \"Let him control you\", which I found very limiting, so I used the Web Bluetooth API to connect it to the browser, and the Web Audio API, to establish my own slogan: \"Let a video control you\".","In my lightning talk, you will learn how to use the Web Bluetooth API to connect a Bluetooth enabled device to the browser. Also, you will see what is possible with the Web Audio API, especially when it comes to analyzing spoken words."],"showReadMore":true},{"id":14,"emoji":"✔️","className":"","time":{"hours":"17","minutes":"20"},"title":"WebAssembly as cross-platform architecture","speakerId":11,"anchor":"Benedek-Gagyi-24-17-00","description":["With the rise of web-to-native cross-platform solutions like React Native and Electron, we got to witness not only their potential, but also their shortcomings. Thanks to WebAssembly we now have an alternative that uses a different approach, but promises the same results.","In my talk, I’ll share the lessons the join.me team learned over the last few years while creating and maintaining a cross-platform (web included!) C++ codebase, with special attention to management and team-dynamic aspects. You’ll also see how WebAssembly changes the game and, through a bit of live-coding, how easy it is to get started with it."],"showReadMore":true},{"id":15,"emoji":"☕️","className":"height90","time":{"hours":"18","minutes":"00"},"title":"Coffee Break","duration":"30 mins","description":[],"showReadMore":false},{"id":16,"emoji":"✔️","className":"denis-radin","time":{"hours":"18","minutes":"30"},"title":"Mining crypto in browser: GPU, WebAssembly, JavaScript and all the good things to try","speakerId":9,"anchor":"Denis-Radin-24-18-10","description":["A year ago an unnamed investor asked me for a consultancy on topic: \"If this is possible to mine crypto in browser using GPU?\". The talk shares some insights/outcome found during the research and gives an idea of what to expect when mining cryptocurrencies using a pool of browser-based miners."],"showReadMore":true},{"id":17,"emoji":"✔️","className":"","time":{"hours":"19","minutes":"10"},"title":"Case Study - React Finland","speakerId":7,"anchor":"Juho-Vepsalainen-24-18-50","description":["Organizing a conference means you require a certain amount of technical infrastructure. We developed a custom website and application for <a target=\"_blank\" href='https://react-finland.fi/'>React Finland</a>. In this talk, you'll learn how we did it and how to achieve a modern frontend architecture using technologies such as Webpack, React, and GraphQL. You will also gain insight on the non-technical aspects including marketing and sales and see how they align with technology."],"showReadMore":true},{"id":18,"emoji":"🏁️","className":"height90","time":{"hours":"19","minutes":"50"},"title":"Closing & Networking","description":[],"showReadMore":false},{"id":19,"emoji":"🍸","className":"height90 party icon","time":{"hours":"20","minutes":"00"},"title":"Wix Afterparty","description":[],"duration":"till midnight","showReadMore":false}]},{"dayId":2,"title":"Day Two","date":"May 25th","day":25,"events":[{"id":20,"emoji":"🥐","className":"","time":{"hours":"10","minutes":"00"},"title":"Breakfast","duration":"1 hour 20 mins","description":["Take some time to enjoy your morning coffee and pastries."],"showReadMore":false},{"id":21,"emoji":"✔️","className":"","time":{"hours":"11","minutes":"20"},"title":"The bumpy road to Universal JavaScript","speakerId":6,"anchor":"Johannes-Ewald-25-12-10","description":["Since the mid 90s, developers have struggled to build web applications that can be executed both on the client and the server. And still today, even with Node.js and virtual DOM libraries like React, this can be quite challenging.","In this talk, we'll look at common obstacles and problems that developers face when building this type of web application, including typical performance and security issues. You'll leave the presentation knowing how to build a fast and secure web application that can be rendered on the client and the server."],"showReadMore":true},{"id":22,"emoji":"✔️","className":"michaela-lehr","time":{"hours":"12","minutes":"00"},"title":"Writing Virtual and Augmented Reality Apps With Web Technology","speakerId":12,"anchor":"Michaela-Lehr-25-13-20","description":["Writing 3D applications for the browser is possible since some years due to the WebGL API. But since Virtual Reality and Augmented Reality are getting more popular, web developers and designers now have a serious reason to get to know the 3D web, its APIs and design patterns.","In this talk you will learn how to create 3D applications in the browser, using the WebGL and the WebVR API, and popular libraries, like A-Frame and ReactVR. You will also see what is necessary to create a Virtual Reality app that runs on common VR devices, and how to create Augmented Reality applications for Android and iOS phones.","Since 3D user interfaces and interactions in the browser are relatively new for designers and users, there are no established UX design patterns yet, but you will get to know best-practices and see some tips for improving the usability of your 3d application.","The talk ends with my advice on how to create responsible applications, that won’t harm your users – neither physically nor psychologically."],"showReadMore":true},{"id":23,"emoji":"🎤","className":"interview icon","time":{"hours":"12","minutes":"40"},"title":"Interview Session with Lea Verou","speakerId":14,"duration":"10 minutes","description":[],"showReadMore":false},{"id":24,"emoji":"☕️","className":"height90","time":{"hours":"12","minutes":"50"},"title":"Coffee Break","duration":"30 mins","description":[],"showReadMore":false},{"id":25,"emoji":"✔️","className":"ronen-amiel","speakerId":13,"anchor":"Ronen-Amiel-25-16-40","time":{"hours":"13","minutes":"20"},"title":"Build your own Webpack (Live coding an ultra-simplified example of a modern module bundler in JavaScript)","description":["Most of us don't have to think too much about module bundlers in our day jobs. However, module bundlers are all around us, and if you’re a web developer you are probably using module bundlers on a daily basis.","Having a good understanding of how popular tools like Webpack or Browserify work can be extremely helpful. In this talk, I will help you understand how most module bundlers work and show you that they’re not as scary as you might think."],"showReadMore":true},{"id":26,"emoji":"✔️","className":"","time":{"hours":"14","minutes":"00"},"title":"Brave New World: Moving on to ES201X","speakerId":2,"anchor":"Benedikt-Meurer-25-14-00","description":["With ES2015 the JavaScript specification changed to a yearly release schedule. Since then we already got another three updates, namely ES2016, ES2017 and most recently ES2018. This puts a lot of pressure on JavaScript VMs to not only keep up with implementing all these new proposals, but continuously think about ways to optimize them, so that developers can not only rely on them being available, but also having reasonable performance.","In this talk, I’ll give an update on the state of the ES201X features and their performance in V8, the JavaScript engine that powers both Node.js and Chrome."],"showReadMore":true},{"id":27,"emoji":"🎤","className":"interview icon","time":{"hours":"14","minutes":"40"},"title":"Interview Session with Vitaly Friedman","speakerId":14,"duration":"10 minutes","description":[],"showReadMore":false},{"id":28,"emoji":"🍽️","className":"height90","time":{"hours":"14","minutes":"50"},"title":"Lunch","duration":"1 hour 30 mins","description":[],"showReadMore":false},{"id":29,"emoji":"⚡","className":"lightning icon opaque-line","time":{"hours":"16","minutes":"20"},"title":"Writing bots for GitHub","speakerId":18,"description":["My talk is going to be about Probot — GitHub's framework for creating bots. A bot built with Probot is a NodeJS application that handles GitHub's events. Probot allows us to automate and improve GitHub workflow, extend it with tools that we love as far as we wish.","In my talk, I will show what Probot can do right now and how you can create your own bot."],"showReadMore":true},{"id":30,"emoji":"⚡","className":"lightning icon opaque-line","time":{"hours":"16","minutes":"30"},"title":"Parcel — bundler: New kid on the block (Zero config comparison with Webpack 4)","speakerId":19,"description":["Parcel is a new web application bundler which doesn’t require a config file whereas in webpack 3, even for a very basic project, we need to configure a `webpack.config` file. So webpack team recently released a new version of webpack (webpack 4) which implements zero config.","I might help in deciding whether one should head over to Webpack 4 or look towards Parcel and what advantages both have."],"showReadMore":true},{"id":31,"emoji":"⚡","className":"lightning icon opaque-line","time":{"hours":"16","minutes":"40"},"title":"DevTools Tips and Tricks","speakerId":20,"anchor":"DevTools-Tips-and-Tricks","description":["We spend a lot of time debugging our code in a browser. But often we just use console.log. In this talk, I will share useful features of DevTools in Chrome and tips and tricks that will help you develop and debug more quickly, easily, and efficiently!"]},{"id":32,"emoji":"⚡","className":"lightning icon opaque-line","time":{"hours":"16","minutes":"50"},"title":"You gotta love Rx","speakerId":21,"description":["Video streaming is a breeze with RxJS, but even if you have nothing to do with the video you do streaming every day. In my lightning talk, I will show you that even something as trivial as handling DOM events could be a fascinating task if you add Observables to it."],"showReadMore":true},{"id":33,"emoji":"✔️","className":"andrey-okonetchnikov","time":{"hours":"17","minutes":"00"},"title":"A common design language: let designers & developers talk to each other","speakerId":10,"anchor":"Andrey-Okonetchnikov-25-17-50","description":["\"Should designers code?\" or \"Should coders design?\"&nbsp;— these 2 eternal questions are being asked for years with no particular answer given.",{"__html":"<ul><li>How to let developers know what typography style or button variance they should be using on this particular screen?</li><li>How to ensure that the whole UI is consistent?</li><li>How to let designers know that some screen design doesn't fit the requirements and needs to be updated?</li></ul>"},"In order to answer those questions designers and developers have to speak the same language. But what language should it be. UI components and pattern libraries can provide this intermediate abstraction and be a common language for both designers and developers.","During this talk, I'll guide you through some frustrations I've experienced as a designer and as a developer when working on different projects. I'll show how the common UI patterns library can solve some of these problems and improve the overall productivity of the team."],"showReadMore":true},{"id":34,"emoji":"🎤","className":"interview icon","time":{"hours":"17","minutes":"40"},"title":"Interview Session with Hui Jing","speakerId":14,"duration":"10 minutes","description":[],"showReadMore":false},{"id":35,"emoji":"☕️","className":"height90","time":{"hours":"17","minutes":"50"},"title":"Coffee Break","duration":"30 mins","description":[],"showReadMore":false},{"id":36,"emoji":"⭐️","time":{"hours":"18","minutes":"20"},"title":"Keynote. New Adventures In Front-End, Season 2","speakerId":5,"anchor":"Vitaly-Friedman-25-18-30","description":["The beast is alive! How do you feel about ASCII-alike CSS Grid layout with polyfluid sizing and ch unit? Do you feel itchy when it comes to building responsive HTML email layouts? What about the brave new world of dynamic static site generators and JAM stack? Have you ever tried to work around nested CSS Custom Properties, untamed 3rd-party scripts, shady service workers, multi-dimensional variable fonts and painfully outdated pattern libraries? Well, let’s bring it on!","If you attended or watched the <a target=\"_blank\" href='https://www.youtube.com/watch?v=cUIfBu0mV08'>first season</a>, you better tighten up your seatbelts: it's an entirely different session, with a slightly different cast and a dash of dirty little front-end tricks. Beware: you will not be able to unlearn what you’ll learn in the session! Ah, one more thing, take the techniques with a grain of salt — we do not take responsibility for sleepless nights and nightmares caused by the content of this session."],"showReadMore":true},{"id":37,"emoji":"🏁️","className":"height90","time":{"hours":"19","minutes":"20"},"title":"Closing part","description":[],"showReadMore":false},{"id":38,"emoji":"🍻️","className":"height90 party icon","time":{"hours":"19","minutes":"30"},"title":"Craft Beer Afterparty","duration":"till midnight","description":[],"showReadMore":false}]}]}

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

	module.exports = {"all":[{"id":1,"firstName":"Lea","lastName":"Verou","position":"Human-Computer Interaction Researcher","company":"MIT CSAIL","description":"Lea is currently busy researching how to make web programming easier at <a href='http://www.csail.mit.edu/' target='_blank'>MIT CSAIL</a>. She is the author of bestselling advanced CSS book <a href='http://shop.oreilly.com/product/0636920031123.do' target='_blank'>CSS Secrets</a> and has worked as a Developer Advocate at <a href='https://www.w3.org/' target='_blank'>W3C</a>. She has a long-standing passion for open web standards, and is one of the few Invited Experts in the <a href='https://www.w3.org/Style/CSS/members.en.php3' target='_blank'>CSS Working Group</a>. Lea has also started <a href='https://github.com/leaverou' target='_blank'>several popular open source projects and web applications</a>, such as <a href='https://mavo.io/' target='_blank'>Mavo</a>, <a href='http://prismjs.com/' target='_blank'>Prism</a>, and <a href='http://leaverou.github.io/prefixfree/' target='_blank'>-prefix-free</a> and maintains a technical blog at <a href='http://lea.verou.me/' target='_blank'>lea.verou.me</a>. She holds a MSc in Computer Science from MIT. Despite her academic pursuits in Computer Science, Lea is one of the few misfits who love code and design equally.","imageSrc":"/speakers/lea_verou","anchor":"Lea-Verou","highlighted":true,"highlightedDescription":"Lea is currently busy researching how to make web programming easier at <a' href='http://www.csail.mit.edu/' target='_blank'>MIT CSAIL</a>. She is the author of bestselling advanced CSS book <a href='http://shop.oreilly.com/product/0636920031123.do' target='_blank'>CSS Secrets</a> and has worked as a Developer Advocate at <a href='https://www.w3.org/' target='_blank'>W3C</a>. She has a long-standing passion for open web standards, and is one of the few Invited Experts in the <a href='https://www.w3.org/Style/CSS/members.en.php3' target='_blank'>CSS Working Group</a>.","social":[{"type":"twitter","url":"https://twitter.com/LeaVerou"},{"type":"github","url":"https://github.com/leaverou"},{"type":"linkedin","url":"https://www.linkedin.com/in/leaverou/"}]},{"id":2,"firstName":"Benedikt","lastName":"Meurer","position":"Technical Lead","company":"Google","description":"Benedikt is a JavaScript compiler engineer who loves to tinker with different aspects of programming languages. <br />In 2013 he joined Google to work on the <a href='https://developers.google.com/v8/' target='_blank'>V8 JavaScript Engine</a> in the Munich office, where he is currently working as tech lead for the Node.js performance team. <br />He spent a rather large amount of his spare time on developing and contributing to open source projects. From 2002 to 2007, he developed and maintained various core parts of the <a href='https://xfce.org' target='_blank'>Xfce desktop environment</a>, including the new file manager <a href='https://docs.xfce.org/xfce/thunar/start' target='_blank'>Thunar</a>, which he wrote from scratch. <br />He is also interested in functional programming languages and compiler design. In 2011 he created a <a href='https://github.com/bmeurer/ocaml-arm/wiki' target='_blank'>brand new ARM port</a> for the <a href='https://caml.inria.fr/ocaml/' target='_blank'>OCaml</a> native code compiler, and since January 2012 he is now the official maintainer of the <a href='https://www.arm.com' target='_blank'>ARM</a> port.","highlightedDescription":"Benedikt is a JavaScript compiler engineer who loves to tinker with different aspects of programming languages. At Google he is working on the <a href='https://developers.google.com/v8/' target='_blank'>V8 JavaScript Engine</a> that powers both Node.js and Chrome, and he is currently leading the Node.js Performance Team.","imageSrc":"/speakers/benedikt_meurer","anchor":"Benedikt-Meurer","highlighted":true,"social":[{"type":"twitter","url":"https://twitter.com/bmeurer"},{"type":"github","url":"https://github.com/bmeurer"},{"type":"linkedin","url":"https://www.linkedin.com/in/benediktmeurer/"}]},{"id":3,"firstName":"Chen Hui","lastName":"Jing","position":"Senior Front-end Developer","company":"Jewel Paymentech","description":"Hui Jing is a self-taught designer and developer from Singapore with an inordinate love of CSS. Reducing lines of code in her web projects makes her extremely happy. She used to play basketball full-time and launched her web career during downtime between training sessions. She also co-organises the <a href='https://singaporecss.github.io' target='_blank'>Talk.CSS Meetup</a>, runs an inspiring <a href='https://www.chenhuijing.com' target='_blank'>web-dev blog</a> and you have to check out her <a href='https://www.chenhuijing.com/talks' target='_blank'>list of talks</a> at numerous conferences and meetups.","highlightedDescription":"Hui Jing is a self-taught designer and developer from Singapore with an inordinate love of CSS. Reducing lines of code in her web projects makes her extremely happy. She used to play basketball full-time and launched her web career during downtime between training sessions.","imageSrc":"/speakers/chen_hui_jing","anchor":"Chen-Hui-Jing","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/hj_chen"},{"type":"github","url":"https://github.com/huijing"},{"type":"linkedin","url":"https://www.linkedin.com/in/huijingchen/"}]},{"id":4,"firstName":"Tomasz","lastName":"Łakomy","position":"Senior Frontend Developer","company":"OLX Group","description":"Tomasz is a Senior Frontend Developer at OLX Group. Co-organiser of React Poznań Meetup, JavaScript tinkerer who enjoys sharing his knowledge with other developers. His interests include VR, AR, React, app performance and making cheesiest jokes known to humanity.","highlightedDescription":"Tomasz is a Senior Frontend Developer at OLX Group. Co-organiser of React Poznań Meetup, JavaScript tinkerer who enjoys sharing his knowledge with other developers. His interests include VR, AR, React, app performance and making cheesiest jokes known to humanity.","imageSrc":"/speakers/tomasz_lakomy","anchor":"Tomasz-Lakomy","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/tlakomy"},{"type":"github","url":"https://github.com/tlakomy"},{"type":"linkedin","url":"https://www.linkedin.com/in/tomasz-łakomy-12b2a258/"}]},{"id":5,"firstName":"Vitaly","lastName":"Friedman","position":"Editor-in-Chief","company":"Smashing Magazine","description":"Vitaly Friedman loves beautiful content and does not give up easily. From Minsk in Belarus, he studied computer science and mathematics in Germany, discovered the passage a passion for typography, writing and design. After working as a freelance designer and developer for 6 years, he co-founded <a href='https://smashingmagazine.com' target='__blank'>Smashing Magazine</a>, a leading online magazine dedicated to design and web development. Vitaly is the author, co-author and editor of all <a href='https://shop.smashingmagazine.com' target='__blank'>Smashing Books</a>.","highlightedDescription":"Vitaly Friedman loves beautiful content and does not give up easily. He currently works as editor-in-chief of <a href='https://smashingmagazine.com' target='__blank'>Smashing Magazine</a> in the lovely city of Freiburg, Germany. Vitaly is the author, co-author and editor of all <a href='https://shop.smashingmagazine.com' target='__blank'>Smashing Books</a>.","imageSrc":"/speakers/vitaly_friedman","anchor":"Vitaly-Friedman","highlighted":true,"social":[{"type":"twitter","url":"https://twitter.com/smashingmag"},{"type":"github","url":"https://github.com/vitalyfriedman"},{"type":"linkedin","url":"https://www.linkedin.com/in/vitalyfriedman/"}]},{"id":6,"firstName":"Johannes","lastName":"Ewald","position":"Core Team Member","company":"Webpack","description":"Passionate <a href='https://github.com/jhnns' target='_blank'>Open Source developer</a>. Founded <a href='https://peerigon.com/' target='_blank'>a company</a> with his friends to develop challenging web projects with JavaScript. Loves music and nature. Member of the <a href='https://webpack.js.org/' target='_blank'>Webpack</a> core team.","highlightedDescription":"Passionate <a href='https://github.com/jhnns' target='_blank'>Open Source developer</a>. Founded <a href='https://peerigon.com/' target='_blank'>a company</a> with his friends to develop challenging web projects with JavaScript. Loves music and nature. Member of the <a href='https://webpack.js.org/' target='_blank'>Webpack</a> core team.","imageSrc":"/speakers/johannes_ewald","anchor":"Johannes-Ewald","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/jhnnns"},{"type":"github","url":"https://github.com/jhnns"}]},{"id":7,"firstName":"Juho","lastName":"Vepsäläinen","position":"Core Team Member","company":"Webpack","description":"Juho Vepsäläinen is behind the <a href='https://survivejs.com/' target='_blank'>SurviveJS</a> effort. In addition to being a core developer of <a href='https://webpack.js.org/' target='_blank'>Webpack</a>, he has been active in the Open Source scene since the early 2000s. Blue Arrow Awards <a href='https://survivejs.com/blog/blue-arrow-awards-winner-2017/' target='_blank'>winner</a>.","highlightedDescription":"Juho Vepsäläinen is behind the <a href='https://survivejs.com/' target='_blank'>SurviveJS</a> effort. In addition to being a core developer of <a href='https://webpack.js.org/' target='_blank'>Webpack</a>, he has been active in the Open Source scene since the early 2000s. Blue Arrow Awards <a href='https://survivejs.com/blog/blue-arrow-awards-winner-2017/' target='_blank'>winner</a>.","imageSrc":"/speakers/juho_vepsalainen","anchor":"Juho-Vepsalainen","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/bebraw"},{"type":"github","url":"https://github.com/bebraw"},{"type":"linkedin","url":"https://www.linkedin.com/in/juhovepsalainen/"}]},{"id":8,"firstName":"Mikhail","lastName":"Novikov","position":"CTO, Co-founder","company":"Reindex","description":"Mikhail is a CTO and Co-founder at Reindex. He started <a href='https://www.reindex.io/' target='_blank'>Reindex</a> as a first GraphQL-focused startup in the world and built first GraphQL Backend-as-a-Service. After BaaS closed, Mikhail has been doing GraphQL consulting. He has also been active in GraphQL open source projects, such as Launchpad and graphql-tools. Before Reindex, Mikhail has been doing web development consulting. He jumped onto React train early and never looked back. Even before that, he used to be a developer at several startups, where he programmed recycling robots and messaging apps in the age before WhatsApp and Telegram.","highlightedDescription":"Mikhail is a CTO and Co-founder at Reindex. He started <a href='https://www.reindex.io/' target='_blank'>Reindex</a> as a first GraphQL-focused startup in  the world and built first GraphQL Backend-as-a-Service. After BaaS closed, Mikhail has been doing GraphQL consulting. He has also been active in GraphQL open source projects, such as Launchpad and graphql-tools. ","imageSrc":"/speakers/mikhail_novikov","anchor":"Mikhail-Novikov","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/freiksenet"},{"type":"github","url":"https://github.com/freiksenet"},{"type":"linkedin","url":"https://www.linkedin.com/in/freiksenet/"}]},{"id":9,"firstName":"Denis","lastName":"Radin","position":"JavaScript Engineer","company":"Evolution Gaming","description":"JavaScript engineer working on photorealistic 3d games at Evolution Gaming. Passionate about performance optimization and code aesthetics, mastering workshop <a href='http://challengingnative.com' target='_blank'>http://challengingnative.com</a>, hosting <a href='https://react.amsterdam/' target='_blank'>https://react.amsterdam</a>, <a href='http://amsterdamjs.com/' target='_blank'>http://amsterdamjs.com</a> as well as running super interesting technical <a href='http://pixelscommander.com/' target='_blank'>blog</a>.","highlightedDescription":"JavaScript engineer working on photorealistic 3d games at Evolution Gaming. Passionate about performance optimization and code aesthetics, mastering workshop <a href='http://challengingnative.com' target='_blank'>http://challengingnative.com</a>, <a href='https://react.amsterdam/' target='_blank'>https://react.amsterdam</a>, <a href='http://amsterdamjs.com/' target='_blank'>http://amsterdamjs.com</a>.","imageSrc":"/speakers/denis_radin","anchor":"Denis-Radin","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/pixelscommander"},{"type":"github","url":"https://github.com/PixelsCommander"},{"type":"linkedin","url":"https://www.linkedin.com/in/denisradin/"}]},{"id":10,"firstName":"Andrey","lastName":"Okonetchnikov","position":"Front-end developer and UI/UX designer","company":"","description":"Andrey is a front-end engineer and UI designer from Russia who lives in Austria and works on modern user interfaces using web technologies. As an active Open Source contributor, he contributed to Webpack, React.js, and Jest; designed the PostCSS official website and created a bunch of logos for other OSS projects.<br/> Andrey is a co-organizer of the ReactVienna community, designer, and co-creator of ColorSnapper. He loves mountain biking, snowboarding, and specialty coffee.","highlightedDescription":"Andrey is a front-end engineer and UI designer from Russia who lives in Austria and works on modern user interfaces using web technologies. As an active Open Source contributor, he contributed to Webpack, React.js, and Jest; designed the PostCSS official website and created a bunch of logos for other OSS projects.","imageSrc":"/speakers/andrey_okonetchnikov","anchor":"Andrey-Okonetchnikov","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/okonetchnikov"},{"type":"github","url":"https://github.com/okonet"}]},{"id":11,"firstName":"Benedek","lastName":"Gagyi","position":"Developer","company":"LogMeIn","description":"Developer, teacher, sports-fanatic. As a developer, he's working on simplifying online collaboration at <a href='https://www.join.me' target='_blank'>join.me</a> by LogMeIn. As a teacher, he's training people in various frontend related fields at <a href='https://www.training360.com/en' target='_blank'>Training360</a>.<br/>In his free time, he's researching the patterns and algorithms connecting basketball, trail running, and drums.<br/>His devotion to impeccable user interfaces is rivaled only by his constant search for the perfect brew of Chinese tea.","highlightedDescription":"Developer, teacher, sports-fanatic. As a developer, he's working on simplifying online collaboration at <a href='https://www.join.me' target='_blank'>join.me</a> by LogMeIn. As a teacher, he's training people in various frontend related fields at <a href='https://www.training360.com/en' target='_blank'>Training360</a>.","imageSrc":"/speakers/benedek_gagyi","anchor":"Benedek-Gagyi","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/benedekgagyi"},{"type":"github","url":"https://github.com/gagyibenedek"}]},{"id":12,"firstName":"Michaela","lastName":"Lehr","position":"Front-end Developer and Designer","company":"GeilDanke","description":"Michaela is a creative front-end developer and designer. She specializes in UX and WebVR and co-founded the studio <a href='https://geildanke.com/en/' target='_blank'>GeilDanke</a>.<br />In her free time, she travels around the world, practices yoga, and watches way too much Buffy.","highlightedDescription":"Michaela is a creative front-end developer and designer. She specializes in UX and WebVR and co-founded the studio <a href='https://geildanke.com/en/' target='_blank'>GeilDanke</a>.","imageSrc":"/speakers/michaela_lehr","anchor":"Michaela-Lehr","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/FischaelaMeer"},{"type":"facebook","url":"https://www.facebook.com/michaela.lehr"}]},{"id":13,"firstName":"Ronen","lastName":"Amiel","position":"Software Developer","company":"Wix","description":"Ronen is a software developer at Wix in the Infra team. He’s working on creating JavaScript tools for developers. Currently, he is busy working on a zero-configuration toolkit, similar to <a href='https://github.com/facebook/create-react-app/' target='_blank'>Create React App</a>, that helps developers bootstrap their projects.<br />Passionate about playing computer games, Ronen started his way by developing his own games with ActionScript. He also loves to understand how things actually work and create simplified versions that show how they are implemented.<br />In his free time, he likes fiddling with functional programming and Haskell in particular, running, rope jumping and playing board games.","highlightedDescription":"Ronen is a software developer from Israel. In the Infra team at Wix, he’s working on creating JavaScript tools for developers. Currently, he is busy working on a zero-configuration toolkit, similar to <a href='https://github.com/facebook/create-react-app/' target='_blank'>Create React App</a>, that helps developers bootstrap their projects.<br />Passionate about playing computer games, Ronen started his way by developing his own games with ActionScript. He also loves to understand how things actually work and create simplified versions that show how they are implemented.","imageSrc":"/speakers/ronen_amiel","anchor":"Ronen-Amiel","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/ronenamiel"},{"type":"github","url":"https://github.com/ronami"}]},{"id":14,"firstName":"Bruce","lastName":"Lawson","position":"MC @ YGLF","company":"Wix","description":"Bruce has been working on accessibility, web standards and browsers since 2001. That's why he looks as bad as he does. He has previously been an assembler programmer, a front-end lead developer, a tarot card reader, volunteer pharmacist in India, English teacher to a Thai princess and a musician in Turkey. You can follow him at <a href='https://twitter.com/brucel' target='_blank'>@brucel</a>, read his ramblings at <a href='http://www.brucelawson.co.uk/' target='_blank'>www.brucelawson.co.uk</a>, or hear his music at <a href='https://soundcloud.com/bruceclawson/' target='_blank'>soundcloud.com</a>.","highlightedDescription":"Bruce has been working on accessibility, web standards and browsers since 2001. That's why he looks as bad as he does. He has previously been an assembler programmer, a front-end lead developer, a tarot card reader, volunteer pharmacist in India, English teacher to a Thai princess and a musician in Turkey","imageSrc":"/speakers/bruce_lawson","anchor":"Bruce-Lawson","highlighted":true,"social":[{"type":"twitter","url":"https://twitter.com/brucel"},{"type":"linkedin","url":"https://www.linkedin.com/in/bruce-lawson-34b44/"}]},{"id":15,"firstName":"Leonid","lastName":"Khachaturov","position":"Lead Frontend Developer","company":"JetBrains","description":"Leonid is a lead front-end developer at <a href='https://www.jetbrains.com/' target='_blank'>JetBrains</a>. He's busy building team tools for developers: <a href='https://www.jetbrains.com/upsource/' target='_blank'>Upsource, a code review tool</a> and open source libraries — <a href='https://www.jetbrains.org/ring-ui/index.html' target='_blank'>Ring UI</a> and <a href='https://github.com/JetBrains/kotlin-wrappers/tree/master/kotlin-css'>kotlin-css</a>. Unlike most front-end developers, he enjoys not writing any HTML, CSS, or JavaScript, preferring to use Kotlin instead. Born in Russia, he's been living in Munich, Germany for the past 6 years. He listens to music for at least 12 hours a day.","highlightedDescription":"Leonid is a lead front-end developer at JetBrains. He's busy building team tools for developers: Upsource, a code review tool and open source libraries — Ring UI and kotlin-css.","imageSrc":"/speakers/leonid_khachaturov","anchor":"Leonid-Khachaturov","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/leonya"},{"type":"github","url":"https://github.com/leonya"}]},{"id":16,"firstName":"Gregory","lastName":"Shehet","position":"Software Engineer and Project Lead","company":"Grammarly","description":"Gregory is working as Software Engineer and Project Lead at <a href='https://grammarly.com/' target='_blank'>Grammarly</a>. He contributes to Focal and MobX. Also, Gregory is the author of <a href='https://github.com/A-gambit/CSS-IN-JS-Benchmarks' target='_blank'>CSS in JS Benchmarks</a> as well as a geek who loves FRP and believes in its power.","highlightedDescription":"Gregory is working as Software Engineer and Project Lead at Grammarly. He contributes to Focal and MobX.","imageSrc":"/speakers/gregory_shehet","anchor":"Gregory-Shehet","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/agambit95"},{"type":"github","url":"https://github.com/A-gambit"}]},{"id":18,"firstName":"Denys","lastName":"Dovhan","position":"Software Consultant","company":"Bizico","description":"Software Consultant, working for Bizico, organizing Chernivtsi JavaScript Community (ChernivtsiJS Conference, BeerJS, Kottans, NodeSchool), coaching and mentoring at DogeCodes React Course, in love with Open Source.","highlightedDescription":"Software Consultant, working for Bizico, organizing Chernivtsi JavaScript Community (ChernivtsiJS Conference, BeerJS, Kottans, NodeSchool).","imageSrc":"/speakers/denys_dovhan","anchor":"Denys-Dovhan","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/denysdovhan"},{"type":"github","url":"https://github.com/denysdovhan"}]},{"id":19,"firstName":"Abhishek","lastName":"Gupta","position":"Javascript developer","company":"Bankomi","description":"Abhishek is building Bankomi which is a real time market data and intelligence platform. He is a Javascript developer and has laid his hands on popular front-end and back-end frameworks. In his free time, he likes to scroll ProductHunt, explore new tools and libraries (currently exploring GraphQL) and watch football.","highlightedDescription":"Abhishek is building Bankomi which is a real time market data and intelligence platform. He is a Javascript developer and has laid his hands on popular front-end and back-end frameworks.","imageSrc":"/speakers/abhishek_gupta","anchor":"Abhishek-Gupta","highlighted":false,"social":[{"type":"twitter","url":"https://twitter.com/ag251994"},{"type":"github","url":"https://github.com/webtaculars"},{"type":"linkedin","url":"https://linkedin.com/in/abhishekgupta2512"}]},{"id":20,"firstName":"Sergei","lastName":"Puzankov","position":"Team Lead","company":"MyHeritage","description":"Sergey is a frontend engineer with more than 15 years of experience in web development. He is working as a team lead for <a href='https://www.myheritage.com/' target='_blank'>MyHeritage</a>, creating high-load and life-changing services. Sergey is passionate about teaching frontend; at <a href='http://frontend-science.com/' target='_blank'>Front-end Science</a> he helps developers become advanced engineers. He loves running, swimming, rock-climbing, and traveling.","highlightedDescription":"Sergey is a frontend engineer with more than 15 years of experience in web development. He is working as a team lead for <a href='https://www.myheritage.com/' target='_blank'>MyHeritage</a>, creating high-load and life-changing services. Sergey is passionate about teaching frontend; at <a href='http://frontend-science.com/' target='_blank'>Front-end Science</a> he helps developers become advanced engineers. He loves running, swimming, rock-climbing, and traveling.","imageSrc":"/speakers/sergei_puzankov","anchor":"Sergei-Puzankov","highlighted":false,"social":[{"type":"linkedin","url":"https://www.linkedin.com/in/puzankov/"},{"type":"facebook","url":"https://www.facebook.com/sergey.puzankov.7"},{"type":"twitter","url":"https://twitter.com/puzankovcom"}]},{"id":21,"firstName":"Helen","lastName":"Zhukova","position":"Frontend developer","company":"VideoGorillas","description":"Helen creates user interfaces for Web and mobile mainly for live video streaming and video post-production for the movie studios. JavaScript is my first love but I am open to any technologies and skills that make my creations the best look and feel. I am a lifelong learner and I love to share my knowledge.","highlightedDescription":"Helen creates user interfaces for Web and mobile mainly for live video streaming and video post-production for the movie studios.","imageSrc":"/speakers/helen_zhukova","anchor":"Helen-Zhukova","highlighted":false,"social":[{"type":"linkedin","url":"https://www.linkedin.com/in/helenzhukova/"},{"type":"facebook","url":"https://www.facebook.com/helen.zhukova.39"},{"type":"github","url":"https://github.com/zhukovka"}]},{"id":22,"firstName":"Oleksandr","lastName":"Pavlyshch","position":"Frontend developer","company":"Astound Commerce","description":"Oleksandr is a front-end developer with five years of experience. He believes that \"machines must suffer\" and that everything is actually works is simple.","highlightedDescription":"He believes that \"Machines must suffer\" and that everything is actually works is simple.","imageSrc":"/speakers/oleksandr_pavlyshch","anchor":"Oleksandr-Pavlyshch","highlighted":false,"social":[{"type":"linkedin","url":"https://ua.linkedin.com/in/oleksandr-pavlyshch-5b6b60b6"},{"type":"twitter","url":"https://twitter.com/lokdawn80"},{"type":"github","url":"https://github.com/OleksandrPavlyshch"}]}]}

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(735)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./react-swipe'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.reactSwipe);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _reactSwipe) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _reactSwipe2.default;
	});

/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('prop-types'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.propTypes);
	    global.reactSwipe = mod.exports;
	  }
	})(this, function (exports, _react, _propTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var supportsCaptureOption = false;
	  function setHasSupportToCaptureOption(hasSupport) {
	    supportsCaptureOption = hasSupport;
	  }
	
	  try {
	    addEventListener("test", null, Object.defineProperty({}, 'capture', { get: function get() {
	        setHasSupportToCaptureOption(true);
	      } }));
	  } catch (e) {}
	
	  function getSafeEventHandlerOpts() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };
	
	    return supportsCaptureOption ? options : options.capture;
	  }
	
	  /**
	   * [getPosition returns a position element that works for mouse or touch events]
	   * @param  {[Event]} event [the received event]
	   * @return {[Object]}      [x and y coords]
	   */
	  function getPosition(event) {
	    if ('touches' in event) {
	      var _event$touches$ = event.touches[0],
	          pageX = _event$touches$.pageX,
	          pageY = _event$touches$.pageY;
	
	      return { x: pageX, y: pageY };
	    }
	
	    var screenX = event.screenX,
	        screenY = event.screenY;
	
	    return { x: screenX, y: screenY };
	  }
	
	  var ReactSwipe = function (_Component) {
	    _inherits(ReactSwipe, _Component);
	
	    function ReactSwipe() {
	      var _ref;
	
	      _classCallCheck(this, ReactSwipe);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));
	
	      _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
	      _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
	      _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);
	
	      _this._onMouseDown = _this._onMouseDown.bind(_this);
	      _this._onMouseMove = _this._onMouseMove.bind(_this);
	      _this._onMouseUp = _this._onMouseUp.bind(_this);
	      return _this;
	    }
	
	    _createClass(ReactSwipe, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.swiper) {
	          this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
	            capture: true,
	            passive: false
	          }));
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.swiper) {
	          this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
	            capture: true,
	            passive: false
	          }));
	        }
	      }
	    }, {
	      key: '_onMouseDown',
	      value: function _onMouseDown(event) {
	        if (!this.props.allowMouseEvents) {
	          return;
	        }
	
	        this.mouseDown = true;
	
	        document.addEventListener('mouseup', this._onMouseUp);
	        document.addEventListener('mousemove', this._onMouseMove);
	
	        this._handleSwipeStart(event);
	      }
	    }, {
	      key: '_onMouseMove',
	      value: function _onMouseMove(event) {
	        if (!this.mouseDown) {
	          return;
	        }
	
	        this._handleSwipeMove(event);
	      }
	    }, {
	      key: '_onMouseUp',
	      value: function _onMouseUp(event) {
	        this.mouseDown = false;
	
	        document.removeEventListener('mouseup', this._onMouseUp);
	        document.removeEventListener('mousemove', this._onMouseMove);
	
	        this._handleSwipeEnd(event);
	      }
	    }, {
	      key: '_handleSwipeStart',
	      value: function _handleSwipeStart(event) {
	        var _getPosition = getPosition(event),
	            x = _getPosition.x,
	            y = _getPosition.y;
	
	        this.moveStart = { x: x, y: y };
	        this.props.onSwipeStart(event);
	      }
	    }, {
	      key: '_handleSwipeMove',
	      value: function _handleSwipeMove(event) {
	        var _getPosition2 = getPosition(event),
	            x = _getPosition2.x,
	            y = _getPosition2.y;
	
	        var deltaX = x - this.moveStart.x;
	        var deltaY = y - this.moveStart.y;
	        this.moving = true;
	
	        // handling the responsability of cancelling the scroll to
	        // the component handling the event
	        var shouldPreventDefault = this.props.onSwipeMove({
	          x: deltaX,
	          y: deltaY
	        }, event);
	
	        if (shouldPreventDefault) {
	          event.preventDefault();
	        }
	
	        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
	      }
	    }, {
	      key: '_handleSwipeEnd',
	      value: function _handleSwipeEnd(event) {
	        this.props.onSwipeEnd(event);
	
	        var tolerance = this.props.tolerance;
	
	
	        if (this.moving) {
	          if (this.movePosition.deltaX < -tolerance) {
	            this.props.onSwipeLeft(1, event);
	          } else if (this.movePosition.deltaX > tolerance) {
	            this.props.onSwipeRight(1, event);
	          }
	          if (this.movePosition.deltaY < -tolerance) {
	            this.props.onSwipeUp(1, event);
	          } else if (this.movePosition.deltaY > tolerance) {
	            this.props.onSwipeDown(1, event);
	          }
	        }
	
	        this.moveStart = null;
	        this.moving = false;
	        this.movePosition = null;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	          this.props.tagName,
	          {
	            ref: function ref(node) {
	              return _this2.swiper = node;
	            },
	            onMouseDown: this._onMouseDown,
	            onTouchStart: this._handleSwipeStart,
	            onTouchEnd: this._handleSwipeEnd,
	            className: this.props.className,
	            style: this.props.style
	          },
	          this.props.children
	        );
	      }
	    }]);
	
	    return ReactSwipe;
	  }(_react.Component);
	
	  ReactSwipe.displayName = 'ReactSwipe';
	  ReactSwipe.propTypes = {
	    tagName: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    children: _propTypes2.default.node,
	    allowMouseEvents: _propTypes2.default.bool,
	    onSwipeUp: _propTypes2.default.func,
	    onSwipeDown: _propTypes2.default.func,
	    onSwipeLeft: _propTypes2.default.func,
	    onSwipeRight: _propTypes2.default.func,
	    onSwipeStart: _propTypes2.default.func,
	    onSwipeMove: _propTypes2.default.func,
	    onSwipeEnd: _propTypes2.default.func,
	    tolerance: _propTypes2.default.number.isRequired
	  };
	  ReactSwipe.defaultProps = {
	    tagName: 'div',
	    allowMouseEvents: false,
	    onSwipeUp: function onSwipeUp() {},
	    onSwipeDown: function onSwipeDown() {},
	    onSwipeLeft: function onSwipeLeft() {},
	    onSwipeRight: function onSwipeRight() {},
	    onSwipeStart: function onSwipeStart() {},
	    onSwipeMove: function onSwipeMove() {},
	    onSwipeEnd: function onSwipeEnd() {},
	
	    tolerance: 0
	  };
	  exports.default = ReactSwipe;
	});

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLazyload = __webpack_require__(57);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	var _FitToRhythm = __webpack_require__(18);
	
	var _FitToRhythm2 = _interopRequireDefault(_FitToRhythm);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _common = __webpack_require__(11);
	
	__webpack_require__(650);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Event = function (_React$Component) {
	  _inherits(Event, _React$Component);
	
	  function Event() {
	    _classCallCheck(this, Event);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.onSpeakerClick = function (e) {
	      e.preventDefault();
	
	      _this.props.onSpeakerClick();
	    };
	
	    _this.scrolltoElTop = function () {
	      window.scrollTo(0, window.scrollY + _this.getElTop() - 90);
	    };
	
	    _this.toggleReadMore = function (e) {
	      e && e.preventDefault();
	      var description = _this.props.data.description;
	
	
	      if (description && description.length) {
	        _this.setState({ opened: !_this.state.opened });
	      }
	
	      _this.scrolltoElTop();
	    };
	
	    _this.state = {
	      opened: false
	    };
	    return _this;
	  }
	
	  Event.prototype.componentDidMount = function componentDidMount() {
	    var anchor = this.props.data.anchor;
	
	    if ((0, _common.isInBrowser)() && window.location.hash.replace('#', '') === anchor) {
	      setTimeout(this.toggleReadMore, 700);
	    }
	  };
	
	  Event.prototype.getElTop = function getElTop() {
	    return this.el.getBoundingClientRect().top;
	  };
	
	  Event.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$data = this.props.data,
	        time = _props$data.time,
	        title = _props$data.title,
	        company = _props$data.company,
	        description = _props$data.description,
	        showReadMore = _props$data.showReadMore,
	        className = _props$data.className,
	        duration = _props$data.duration,
	        anchor = _props$data.anchor,
	        emoji = _props$data.emoji,
	        _props$data$speakerDa = _props$data.speakerData,
	        speakerName = _props$data$speakerDa.speakerName,
	        imageSrc = _props$data$speakerDa.imageSrc,
	        speakerAnchor = _props$data$speakerDa.anchor;
	    var day = this.props.day;
	    var opened = this.state.opened;
	
	    var computedClass = (0, _classnames2.default)('event', className, {
	      '-opened': opened,
	      '-read-more-hidden': !showReadMore,
	      '-no-description': !description.length,
	      'emoji': emoji && emoji !== '✔️'
	    });
	    var dateTime = '2018-05-' + day + 'T' + time.hours + ':' + time.minutes;
	
	    return _react2.default.createElement(
	      'div',
	      { 'data-anchor': anchor, className: computedClass, ref: function ref(el) {
	          _this2.el = el;
	        } },
	      _react2.default.createElement(
	        'div',
	        { className: 'time-box' },
	        _react2.default.createElement(
	          'span',
	          { className: 'now' },
	          'Now'
	        ),
	        _react2.default.createElement(
	          'time',
	          { className: 'time auto-height-fix-time', dateTime: dateTime },
	          emoji && emoji !== '✔️' && _react2.default.createElement(
	            'span',
	            { className: 'emoji' },
	            emoji
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'hours' },
	            time.hours
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'minutes' },
	            time.minutes
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'info-wrapper' },
	        _react2.default.createElement(
	          _FitToRhythm2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'info' },
	            _react2.default.createElement(
	              _FitToRhythm2.default,
	              { className: 'title-wrapper' },
	              speakerName && _react2.default.createElement(
	                'div',
	                { className: 'speaker-img', onClick: this.onSpeakerClick },
	                _react2.default.createElement(
	                  _reactLazyload2.default,
	                  { offset: 150 },
	                  _react2.default.createElement('img', { src: imageSrc + '.jpg', className: '-drop-shadow', alt: speakerName })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'info-description' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#' + anchor },
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'info-description-title' },
	                    title,
	                    duration && _react2.default.createElement(
	                      'span',
	                      { className: 'info-description-time' },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        ','
	                      ),
	                      ' ',
	                      duration
	                    )
	                  )
	                ),
	                speakerName ? _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'info-description-speaker',
	                    onClick: this.onSpeakerClick,
	                    href: '/speakers#' + speakerAnchor
	                  },
	                  speakerName,
	                  ' ',
	                  company && '(' + company + ')'
	                ) : ''
	              )
	            ),
	            !!description.length && _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('description', { '-can-show-more': showReadMore }) },
	              description.map(function (item) {
	                return typeof item === 'string' ? _react2.default.createElement('p', { key: item, dangerouslySetInnerHTML: { __html: item } }) : _react2.default.createElement('div', { key: item, dangerouslySetInnerHTML: item });
	              })
	            )
	          )
	        )
	      ),
	      showReadMore && [_react2.default.createElement(
	        'a',
	        {
	          href: '#' + anchor,
	          onClick: this.toggleReadMore,
	          className: 'event-read-more',
	          key: 'event-read-more'
	        },
	        'Read more'
	      ), _react2.default.createElement(
	        'a',
	        {
	          href: '#' + anchor,
	          onClick: this.toggleReadMore,
	          className: 'event-read-less',
	          key: 'event-read-less'
	        },
	        'Less'
	      )]
	    );
	  };
	
	  return Event;
	}(_react2.default.Component);
	
	Event.propTypes = {
	  data: _react.PropTypes.object, // add more types
	  date: _react.PropTypes.number,
	  onSpeakerClick: _react.PropTypes.func
	};
	Event.defaultProps = {
	  data: {},
	  onSpeakerClick: function onSpeakerClick() {}
	};
	exports.default = Event;
	module.exports = exports['default'];

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SocialIcons = __webpack_require__(31);
	
	var _SocialIcons2 = _interopRequireDefault(_SocialIcons);
	
	var _reactLazyload = __webpack_require__(57);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactEasySwipe = __webpack_require__(734);
	
	var _reactEasySwipe2 = _interopRequireDefault(_reactEasySwipe);
	
	__webpack_require__(651);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventSpeaker = function (_React$Component) {
	  _inherits(EventSpeaker, _React$Component);
	
	  function EventSpeaker() {
	    _classCallCheck(this, EventSpeaker);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      visible: false
	    };
	    _this.close = _this.close.bind(_this);
	    return _this;
	  }
	
	  EventSpeaker.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      return _this2.setState({ visible: true });
	    }, 0);
	  };
	
	  EventSpeaker.prototype.close = function close() {
	    var _this3 = this;
	
	    this.setState({ visible: false }, function () {
	      setTimeout(_this3.props.onOverlayClick, 300);
	    });
	  };
	
	  EventSpeaker.prototype.renderSpeaker = function renderSpeaker() {
	    var _props$data = this.props.data,
	        firstName = _props$data.firstName,
	        lastName = _props$data.lastName,
	        imageSrc = _props$data.imageSrc,
	        social = _props$data.social,
	        position = _props$data.position,
	        company = _props$data.company,
	        description = _props$data.description,
	        anchor = _props$data.anchor;
	
	
	    var className = 'event-speaker-data';
	
	    return _react2.default.createElement(
	      'div',
	      { className: className },
	      _react2.default.createElement(
	        'div',
	        { className: 'event-speaker-data-cols' },
	        _react2.default.createElement('a', { href: '', name: anchor, className: '-no-outline anchor' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'event-speaker-data-img' },
	          _react2.default.createElement(
	            _reactLazyload2.default,
	            { offset: 150 },
	            _react2.default.createElement('img', {
	              src: imageSrc + '.jpg',
	              className: '-drop-shadow',
	              alt: firstName + ' ' + lastName
	            })
	          ),
	          _react2.default.createElement(_SocialIcons2.default, { data: social })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'event-speaker-data-text' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'person-first-name' },
	              firstName
	            ),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { className: 'person-last-name' },
	              lastName
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            position && _react2.default.createElement(
	              'span',
	              { className: 'person-position' },
	              position
	            ),
	            company && _react2.default.createElement(
	              'span',
	              { className: 'person-company' },
	              company
	            )
	          ),
	          _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: description } })
	        )
	      )
	    );
	  };
	
	  EventSpeaker.prototype.render = function render() {
	    var visible = this.state.visible;
	
	    return _react2.default.createElement(
	      _reactEasySwipe2.default,
	      {
	        className: (0, _classnames2.default)('event-speaker', { '-visible': visible }),
	        onSwipeRight: this.close,
	        tolerance: 150
	      },
	      _react2.default.createElement('div', { className: 'overlay', onClick: this.close }),
	      this.renderSpeaker()
	    );
	  };
	
	  return EventSpeaker;
	}(_react2.default.Component);
	
	EventSpeaker.propTypes = {
	  data: _react.PropTypes.object, // add more types
	  onOverlayClick: _react.PropTypes.func
	};
	EventSpeaker.defaultProps = {
	  data: {},
	  onOverlayClick: function onOverlayClick() {}
	};
	exports.default = EventSpeaker;
	module.exports = exports['default'];

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(664);
	
	var _ga = __webpack_require__(10);
	
	var _Event = __webpack_require__(253);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _EventSpeaker = __webpack_require__(254);
	
	var _EventSpeaker2 = _interopRequireDefault(_EventSpeaker);
	
	var _schedule = __webpack_require__(73);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _speakers = __webpack_require__(26);
	
	var _speakers2 = _interopRequireDefault(_speakers);
	
	var _common = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SCHEDULE = (0, _common.constructSchedule)(_schedule2.default.days, _speakers2.default.all);
	
	var SchedulePage = function (_React$Component) {
	  _inherits(SchedulePage, _React$Component);
	
	  function SchedulePage(props) {
	    _classCallCheck(this, SchedulePage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      activeDay: (0, _common.getActiveDay)() || 24,
	      dayOpaque: true,
	      activeSpeaker: null,
	      isSticky: false,
	      menuHidden: false,
	      currentEvent: (0, _common.getCurrentEvent)(SCHEDULE)
	    };
	
	    _this.dayEls = { 24: null, 25: null };
	
	    if ((0, _common.isEventDay)()) {
	      (0, _common.nextUpdatesIn)(SCHEDULE).forEach(function (eventTime) {
	        setTimeout(_this.updateCurrentEventState.bind(_this), eventTime);
	      });
	    }
	
	    _this.hideSpeaker = _this.hideSpeaker.bind(_this);
	    _this.onWindowScroll = _this.onWindowScroll.bind(_this);
	    _this.getDayElTop = _this.getDayElTop.bind(_this);
	    _this.scrollToActiveDay = _this.scrollToActiveDay.bind(_this);
	    _this.scrollToActiveEvent = _this.scrollToActiveEvent.bind(_this);
	    _this.updateCurrentEventState = _this.updateCurrentEventState.bind(_this);
	    return _this;
	  }
	
	  SchedulePage.prototype.componentWillMount = function componentWillMount() {
	    (0, _ga.gaTrack)({
	      eventCategory: 'schedule',
	      eventAction: 'schedule',
	      eventLabel: 'schedule'
	    });
	  };
	
	  SchedulePage.prototype.componentDidMount = function componentDidMount() {
	    var shouldBeScrolled = (0, _common.isInBrowser)() && !window.location.hash.substr(1) && (0, _common.isEventDay)();
	
	    (0, _common.isInBrowser)() && window.addEventListener('scroll', this.onWindowScroll);
	
	    if (shouldBeScrolled && !this.state.currentEvent) {
	      setTimeout(this.scrollToActiveDay, 700);
	    } else if (shouldBeScrolled && this.state.currentEvent) {
	      setTimeout(this.scrollToActiveEvent, 700);
	    }
	  };
	
	  SchedulePage.prototype.componentWillUnmount = function componentWillUnmount() {
	    (0, _common.isInBrowser)() && window.removeEventListener('scroll', this.onWindowScroll);
	  };
	
	  SchedulePage.prototype.updateCurrentEventState = function updateCurrentEventState() {
	    this.setState({
	      currentEvent: (0, _common.getCurrentEvent)(SCHEDULE)
	    });
	  };
	
	  SchedulePage.prototype.getDayElTop = function getDayElTop(day) {
	    return this.dayEls[day].getBoundingClientRect().top;
	  };
	
	  SchedulePage.prototype.getLastEventTop = function getLastEventTop() {
	    return this.lastEventEl.getBoundingClientRect().top;
	  };
	
	  SchedulePage.prototype.onWindowScroll = function onWindowScroll() {
	    var day24Position = this.getDayElTop(24);
	    var day25Position = this.getDayElTop(25);
	    var lastEventPosition = this.getLastEventTop();
	    var activeDay = day25Position > 0 ? 24 : 25;
	    var isSticky = day24Position < 0;
	    var menuHidden = lastEventPosition < 0;
	    if (activeDay !== this.state.activeDay) {
	      this.setState({ activeDay: activeDay });
	    }
	    if (isSticky !== this.state.isSticky) {
	      this.setState({ isSticky: isSticky });
	    }
	    if (menuHidden !== this.state.menuHidden) {
	      this.setState({ menuHidden: menuHidden });
	    }
	  };
	
	  SchedulePage.prototype.toggle = function toggle(activeDay) {
	    this.setState({ activeDay: activeDay }, this.scrollToActiveDay);
	  };
	
	  SchedulePage.prototype.scrollToActiveDay = function scrollToActiveDay() {
	    window.scrollTo(0, window.scrollY + this.getDayElTop(this.state.activeDay));
	  };
	
	  SchedulePage.prototype.scrollToActiveEvent = function scrollToActiveEvent() {
	    var _getCurrentEvent = (0, _common.getCurrentEvent)(SCHEDULE),
	        anchor = _getCurrentEvent.anchor;
	
	    var top = document.querySelector('[data-anchor="' + anchor + '"]').getBoundingClientRect().top;
	
	    window.scrollTo(0, window.scrollY + top - 90);
	  };
	
	  SchedulePage.prototype.showSpeaker = function showSpeaker(speakerData) {
	    this.setState({ activeSpeaker: speakerData });
	    window.document.documentElement.style.overflow = 'hidden';
	  };
	
	  SchedulePage.prototype.hideSpeaker = function hideSpeaker() {
	    this.setState({ activeSpeaker: null });
	    window.document.documentElement.style.overflow = 'auto';
	  };
	
	  SchedulePage.prototype.renderDaysMenu = function renderDaysMenu() {
	    var _this2 = this;
	
	    var _state = this.state,
	        activeDay = _state.activeDay,
	        isSticky = _state.isSticky,
	        menuHidden = _state.menuHidden;
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('days-menu-wrapper', { '-sticky': isSticky, '-hidden': menuHidden }) },
	      _react2.default.createElement(
	        'ul',
	        { className: 'days-menu' },
	        SCHEDULE.map(function (day) {
	          return _react2.default.createElement(
	            'li',
	            {
	              className: '' + (activeDay === day.day ? '' : '-inactive'),
	              key: day.title,
	              onClick: _this2.toggle.bind(_this2, day.day)
	            },
	            _react2.default.createElement(
	              'h2',
	              { className: 'title' },
	              day.title
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'date' },
	              day.date
	            )
	          );
	        })
	      )
	    );
	  };
	
	  SchedulePage.prototype.renderDays = function renderDays() {
	    var _this3 = this;
	
	    return SCHEDULE.map(function (day) {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'day day-' + day.day,
	          key: day.title,
	          ref: function ref(el) {
	            _this3.dayEls[day.day] = el;
	          }
	        },
	        day.day === 25 && _react2.default.createElement(
	          'div',
	          { className: 'day-25-header' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title' },
	            day.title
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'date' },
	            day.date
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'events' },
	          day.events.map(function (event, index) {
	            var isCurrent = _this3.state.currentEvent && event.id === _this3.state.currentEvent.id;
	
	            return _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)("event-holder", { "-isCurrent": isCurrent }),
	                key: index,
	                ref: function ref(el) {
	                  if (day.day === 25 && index === day.events.length - 1) {
	                    _this3.lastEventEl = el;
	                  }
	                }
	              },
	              _react2.default.createElement(_Event2.default, {
	                day: day.day,
	                data: event,
	                key: index,
	                onSpeakerClick: _this3.showSpeaker.bind(_this3, event.speakerData)
	              })
	            );
	          })
	        )
	      );
	    });
	  };
	
	  SchedulePage.prototype.renderActiveSpeaker = function renderActiveSpeaker() {
	    var activeSpeaker = this.state.activeSpeaker;
	
	    return activeSpeaker ? _react2.default.createElement(_EventSpeaker2.default, { data: activeSpeaker, onOverlayClick: this.hideSpeaker }) : null;
	  };
	
	  SchedulePage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'page-schedule lines-bg' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container container-fluid' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Schedule'
	        ),
	        this.renderDaysMenu(),
	        this.renderDays(),
	        this.renderActiveSpeaker()
	      )
	    );
	  };
	
	  return SchedulePage;
	}(_react2.default.Component);
	
	exports.default = SchedulePage;
	module.exports = exports['default'];

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-schedule-js-641d621788f48eaa6ca0.js